<template>
  <!-- eslint-disable vue/no-v-text-v-html-on-component-->
  <component
    :is="tag"
    v-if="html"
    class="aj-text"
    :class="classObject"
    v-on="$listeners"
    v-html="html"
  />
  <component
    :is="tag"
    v-else
    class="aj-text"
    :class="classObject"
    v-on="$listeners"
  >
    <slot />
  </component>
</template>

<script>
/**
 * Use `AjText` for text elements
 */
export default {
  name: 'AjText',

  props: {
    html: {
      type: String,
      default: '',
    },
    tag: {
      type: String,
      default: 'p',
    },
    headlineLarge: {
      type: Boolean,
      default: false,
    },
    headlineBig: {
      type: Boolean,
      default: false,
    },
    headlineMedium: {
      type: Boolean,
      default: false,
    },
    headlineSmall: {
      type: Boolean,
      default: false,
    },
    subtitle: {
      type: Boolean,
      default: false,
    },
    bold: {
      type: Boolean,
      default: false,
    },
    black: {
      type: Boolean,
      default: false,
    },
    bodyLarge: {
      type: Boolean,
      default: false,
    },
    bodyMedium: {
      type: Boolean,
      default: false,
    },
    bodySmall: {
      type: Boolean,
      default: false,
    },
    bodyLow: {
      type: Boolean,
      default: false,
    },
    overline: {
      type: Boolean,
      default: false,
    },
    uppercase: {
      type: Boolean,
      default: false,
    },
    lowercase: {
      type: Boolean,
      default: false,
    },
    capitalize: {
      type: Boolean,
      default: false,
    },
    underline: {
      type: Boolean,
      default: false,
    },
    lineThrough: {
      type: Boolean,
      default: false,
    },
    center: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classObject () {
      return {
        '-headlineLarge': this.headlineLarge,
        '-headlineBig': this.headlineBig,
        '-headlineMedium': this.headlineMedium,
        '-headlineSmall': this.headlineSmall,
        '-subtitle': this.subtitle,
        '-bold': this.bold,
        '-black': this.black,
        '-bodyLarge': this.bodyLarge,
        '-bodyMedium': this.bodyMedium,
        '-bodySmall': this.bodySmall,
        '-bodyLow': this.bodyLow,
        '-overline': this.overline,
        '-uppercase': this.uppercase,
        '-lowercase': this.lowercase,
        '-capitalize': this.capitalize,
        '-underline': this.underline,
        '-lineThrough': this.lineThrough,
        '-center': this.center,
      };
    },
  },
};
</script>

<style lang="scss" src="./AjText.scss" scoped />
